import React, { FunctionComponent } from "react"
import { useParams } from "react-router-dom"
import { Button, Icon } from "@kuali/pure-ui"
import "../../base/block-anchor.scss"

interface Props {
  formId: string
  formState: FormStateProps
}
interface FormStateProps {
  needsSave: boolean
  loading: boolean
}

const ActionSidebar: FunctionComponent<Props> = ({ formId, formState }) => {
  // We can use the `useParams` hook here to access
  // the dynamic pieces of the URL.
  const { planName, criticalFunctionName, viewType, appPrefix } = useParams()
  const isPageInEditMode = viewType === "edit"
  let domainPrefix = ""

  if (appPrefix) {
    domainPrefix = "/" + appPrefix
  }

  const addItemPath =
    `${domainPrefix}/plans/${planName}/action-items/new?redirect_to=` +
    document.location.pathname
  const viewPath = `${domainPrefix}/plans/${planName}/critical-functions/${criticalFunctionName}/levels-of-criticality`
  const editPath = `${domainPrefix}/plans/${planName}/critical-functions/${criticalFunctionName}/levels-of-criticality/edit`
  const printPath = `${domainPrefix}/plans/${planName}/print`

  return (
    <React.Fragment>
      <div className="page-controls expanded">
        <div className="row stack --mini-stack">
          {/* Below button handles native HTML form submit for `form` id/name
              This will trigger any functionality tied to the specificed form's `submit`
          */}
          <Button
            size="large"
            block={true}
            kind={formState.needsSave ? "outline" : "solid"}
            disabled={!isPageInEditMode}
            loading={formState.loading}
            form={formId}
            buttonProps={{
              form: formId,
              type: "submit"
            }}
          >
            <Icon name="check" /> Save{formState.needsSave ? "" : "d"}
          </Button>
          {/* Note: For legacy modal the `reveal-ajax` attribute must be present */}
          <a
            className="button shadow outline"
            data-reveal-ajax={true}
            href={addItemPath}
          >
            <div className="buttonIcon">
              <Icon name="add" />
            </div>
            <div className="buttonContent">New action Item</div>
          </a>
          {isPageInEditMode && (
            <a className="button shadow outline" href={viewPath}>
              <div className="buttonIcon">
                <Icon name="book" />
              </div>
              <div className="buttonContent">View Page</div>
            </a>
          )}
          {!isPageInEditMode && (
            <a className="button shadow outline" href={editPath}>
              <div className="buttonIcon">
                <Icon name="edit" />
              </div>
              <div className="buttonContent">Edit Page</div>
            </a>
          )}
          <a
            className="button shadow outline"
            href={printPath}
            rel="noreferrer"
            target="_blank"
          >
            <div className="buttonIcon">
              <Icon name="print" />
            </div>
            <div className="buttonContent">Print PDF</div>
          </a>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ActionSidebar
